// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node-contextmenu[data-v-33e81750]{position:fixed}", ""]);
// Exports
module.exports = exports;
